import { Link } from "react-router-dom";
import { AshokaChakra } from "@/components/AshokaChakra";
import { NewsletterForm } from "@/components/Newsletter";

export function Footer() {
  return (
    <footer className="relative z-10 mt-24 border-t border-[var(--line)] tricolor-light-h backdrop-blur-sm" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <AshokaChakra className="h-8 w-8 text-[var(--chakra)]" />
            <span className="font-devanagari text-2xl text-[var(--chakra-deep)]">भारत गाथा</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-stone-600">
            Stories of India's roots, growth and place in the world, written for the people of India.
          </p>
        </div>
        <div>
          <p className="eyebrow text-[var(--saffron-deep)]">Explore</p>
          <ul className="mt-4 space-y-2 text-sm text-stone-700">
            <li><Link to="/articles" className="hover:text-[var(--chakra)]">All articles</Link></li>
            <li><Link to="/#roots" className="hover:text-[var(--chakra)]">Root of India</Link></li>
            <li><Link to="/#growth" className="hover:text-[var(--chakra)]">Growth Story</Link></li>
            <li><Link to="/#geopolitics" className="hover:text-[var(--chakra)]">Geopolitics</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow text-[var(--india-green)]">सत्यमेव जयते</p>
          <p className="mt-4 font-serif text-lg italic text-[var(--chakra-deep)]">"Truth alone triumphs."</p>
          <p className="mt-1 text-xs text-stone-500">Mundaka Upanishad, national motto of India</p>
          <p className="eyebrow mt-8 text-[var(--saffron-deep)]">New article alerts</p>
          <div className="mt-3"><NewsletterForm compact /></div>
        </div>
      </div>
      <div className="tricolor-bar h-1.5 w-full" />
      <p className="py-4 text-center text-xs text-stone-500">© {new Date().getFullYear()} Bharat Gatha. Made with love in India.</p>
    </footer>
  );
}
